// Named imports only (never `import * as`) — lucide-react ships 1000+ icons,
// and a namespace import pulls the whole library into the bundle even though
// only the curated ICON_MAP below is ever referenced (bundle size went
// 377kB -> 1.3MB when this was `import * as icons`).
import {
  LayoutDashboard,
  Home,
  Users,
  User,
  UserCog,
  UserPlus,
  UsersRound,
  Dumbbell,
  Trophy,
  Medal,
  Award,
  Target,
  Flag,
  CalendarDays,
  CalendarClock,
  CalendarCheck,
  Clock,
  Building2,
  Building,
  Landmark,
  ShieldCheck,
  Shield,
  Settings,
  Settings2,
  SlidersHorizontal,
  ClipboardList,
  ClipboardCheck,
  ListChecks,
  ListTodo,
  FileText,
  Files,
  FolderOpen,
  Mail,
  MessageCircle,
  Bell,
  BellRing,
  Megaphone,
  Star,
  Heart,
  Palette,
  Paintbrush,
  Image,
  Camera,
  Video,
  Music,
  MapPin,
  Map,
  Compass,
  Globe,
  Link as LinkIcon,
  ExternalLink,
  Wifi,
  Radio,
  Tv,
  Gamepad2,
  Volleyball,
  CircleDot,
  Zap,
  Activity,
  TrendingUp,
  BarChart3,
  PieChart,
  LineChart,
  Wallet,
  CreditCard,
  Banknote,
  Coins,
  Receipt,
  ShoppingCart,
  Package,
  Truck,
  Warehouse,
  Key,
  Lock,
  Unlock,
  Eye,
  Search,
  Filter,
  Grid3x3,
  LayoutGrid,
  Table,
  Rows3,
  Columns3,
  Layers,
  Puzzle,
  Wrench,
  Hammer,
  Cog,
  Database,
  Server,
  Cloud,
  CloudUpload,
  CloudDownload,
  Download,
  Upload,
  Share2,
  Send,
  Inbox,
  Archive,
  Trash2,
  RefreshCw,
  RotateCcw,
  Plus,
  Check,
  X,
  AlertCircle,
  Info,
  HelpCircle,
  BookOpen,
  Book,
  GraduationCap,
  School,
  Briefcase,
  IdCard,
  ContactRound,
  PhoneCall,
  Smartphone,
  Laptop,
  Monitor,
  Printer,
  Sun,
  Moon,
  Sparkles,
  Flame,
  Droplet,
  Leaf,
  TreePine,
  Mountain,
  Waves,
  Bike,
  Car,
  Bus,
  Plane,
  Anchor,
  Rocket,
  Crown,
  Gem,
  Gift,
  PartyPopper,
  Handshake,
  ThumbsUp,
  Circle,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  LayoutDashboard,
  Home,
  Users,
  User,
  UserCog,
  UserPlus,
  UsersRound,
  Dumbbell,
  Trophy,
  Medal,
  Award,
  Target,
  Flag,
  CalendarDays,
  CalendarClock,
  CalendarCheck,
  Clock,
  Building2,
  Building,
  Landmark,
  ShieldCheck,
  Shield,
  Settings,
  Settings2,
  SlidersHorizontal,
  ClipboardList,
  ClipboardCheck,
  ListChecks,
  ListTodo,
  FileText,
  Files,
  FolderOpen,
  Mail,
  MessageCircle,
  Bell,
  BellRing,
  Megaphone,
  Star,
  Heart,
  Palette,
  Paintbrush,
  Image,
  Camera,
  Video,
  Music,
  MapPin,
  Map,
  Compass,
  Globe,
  Link: LinkIcon,
  ExternalLink,
  Wifi,
  Radio,
  Tv,
  Gamepad2,
  Volleyball,
  CircleDot,
  Zap,
  Activity,
  TrendingUp,
  BarChart3,
  PieChart,
  LineChart,
  Wallet,
  CreditCard,
  Banknote,
  Coins,
  Receipt,
  ShoppingCart,
  Package,
  Truck,
  Warehouse,
  Key,
  Lock,
  Unlock,
  Eye,
  Search,
  Filter,
  Grid3x3,
  LayoutGrid,
  Table,
  Rows3,
  Columns3,
  Layers,
  Puzzle,
  Wrench,
  Hammer,
  Cog,
  Database,
  Server,
  Cloud,
  CloudUpload,
  CloudDownload,
  Download,
  Upload,
  Share2,
  Send,
  Inbox,
  Archive,
  Trash2,
  RefreshCw,
  RotateCcw,
  Plus,
  Check,
  X,
  AlertCircle,
  Info,
  HelpCircle,
  BookOpen,
  Book,
  GraduationCap,
  School,
  Briefcase,
  IdCard,
  ContactRound,
  PhoneCall,
  Smartphone,
  Laptop,
  Monitor,
  Printer,
  Sun,
  Moon,
  Sparkles,
  Flame,
  Droplet,
  Leaf,
  TreePine,
  Mountain,
  Waves,
  Bike,
  Car,
  Bus,
  Plane,
  Anchor,
  Rocket,
  Crown,
  Gem,
  Gift,
  PartyPopper,
  Handshake,
  ThumbsUp,
};

/** Default icon per nav item key (AppShell's `nav` array), used until an org picks its own.
 * `members` is no longer a top-level nav key (moved into Verein's ORG_TABS, see
 * `OrgTabs.tsx`) but stays here for DashboardPage's Schnellzugriff icon lookup. */
export const DEFAULT_NAV_ICONS: Record<string, string> = {
  dashboard: 'LayoutDashboard',
  members: 'Users',
  training: 'Dumbbell',
  season: 'Trophy',
  calendar: 'CalendarDays',
  equipment: 'ShoppingCart',
  administration: 'Settings2',
};

/** A broad, varied selection (ISC-licensed, free, bundled — no external calls) —
 * enough choice for any nav item without shipping a 1000+-icon picker UI. */
export const NAV_ICON_CHOICES: string[] = Object.keys(ICON_MAP);

/** Look up an icon component by name (arbitrary/user-stored string), falling
 * back to a generic dot if the name is unset or no longer valid/curated. */
export function resolveIcon(name: string | undefined): LucideIcon {
  return (name && ICON_MAP[name]) || Circle;
}
